/**
 * @namespace {BX.UI}
 */
export default class ButtonStyle
{
	static NO_CAPS = 'ui-btn-no-caps';
	static ROUND = 'ui-btn-round';
	static DROPDOWN = 'ui-btn-dropdown';
	static COLLAPSED = 'ui-btn-collapsed';
	static DEPEND_ON_THEME = 'ui-btn-themes';
}